import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useIntl } from 'react-intl';

import LandingSection from '../../../MyComponents/LandingSections/LandingSection';
import SectionHeading from '../../../MyComponents/LandingSections/SectionHeading';
import useAfterPageLoad from '../../../MyComponents/Hooks/useAfterPageLoad';
import { REDESIGN_COLORS, VIDEO_URLS } from '../../../constants';

const useStyles = makeStyles((theme) => ({
    frame: {
        position: 'relative',
        overflow: 'hidden',
        // A padding-top ratio box rather than aspect-ratio: browsers before
        // Chrome 88 (older interactive whiteboards) ignore aspect-ratio, which
        // left this frame 0px tall and the video invisible.
        '&::before': { content: '""', display: 'block', paddingTop: '56.25%' },
        border: `8px solid ${REDESIGN_COLORS.white}`,
        borderRadius: '26px',
        background: REDESIGN_COLORS.dark,
        boxShadow: `0 24px 70px rgba(2, 71, 77, 0.13), 0 0 0 1px ${REDESIGN_COLORS.line}`,
        [theme.breakpoints.down('xs')]: {
            borderWidth: '6px',
            borderRadius: '20px',
        },
    },
    iframe: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        border: 0,
    },
}));

/**
 * The `#video` section of the redesign. The hero used to carry the product
 * video; the new design gives it its own band right below.
 */
const HomeVideo = ({ language, video = 'main', titleId = 'redesign.home.video.title' }) => {
    const classes = useStyles();
    const intl = useIntl();

    const locale = (language || 'en').toUpperCase();
    const videoUrl = VIDEO_URLS[video][locale] || VIDEO_URLS[video]['EN'];
    // The autoplaying embed never finishes loading its document, and an
    // iframe in flight blocks the window load event - which the service
    // worker registration and PWA scanners wait for. Mount it after load.
    const pageLoaded = useAfterPageLoad();

    return (
        <LandingSection id="video" maxWidth={980} paddingTop={24} paddingBottom={56}>
            <SectionHeading
                title={intl.formatMessage({ id: titleId })}
                titleSize="clamp(1.35rem, 2.2vw, 1.8rem)"
                marginBottom={22}
            />
            <div className={classes.frame}>
                {pageLoaded ? (
                    <iframe
                        src={videoUrl}
                        title={intl.formatMessage({ id: 'redesign.home.video.iframeTitle' })}
                        loading="lazy"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                        className={classes.iframe}
                    />
                ) : null}
            </div>
        </LandingSection>
    );
};

export default HomeVideo;
